import defineComponent from 'flight'

function NavigationTimeMetrics() {

    let navEvent;
    let beforePageLoadTime;
    let afterPageLoadTime;
    let afterPageChangeTime;

    this.defaultAttrs({
        pageName: null,
        areaName: null
    });

    this._beforePageLoad = function () {
        beforePageLoadTime = new Date().getTime();

        navEvent = {
            eventName: 'navigation-timing',
            sourcePage: this.attr.pageName,
            sourceArea: this.attr.areaName,
            sourcePath: window.location.pathname
        };
    };

    this._afterPageLoad = function () {
        afterPageLoadTime = new Date().getTime();
    };

    this._afterPageChange = function () {
        // search pagination only triggers after page change
        // it hacks the pjax navigation, this should be measured also
        // but for now skip measure pagination navigations
        if (!navEvent || (!afterPageLoadTime && !beforePageLoadTime)) {
            return;
        }

        afterPageChangeTime = new Date().getTime();

        navEvent.load_page_ms = afterPageLoadTime - beforePageLoadTime;
        navEvent.update_and_boot_page_ms = afterPageChangeTime - afterPageLoadTime;
        navEvent.total_ms = afterPageChangeTime - beforePageLoadTime;
        navEvent.destPage = this.attr.pageName;
        navEvent.destArea = this.attr.areaName;
        navEvent.destPath = window.location.pathname;

        this.trigger(document, 'data:scribe', navEvent);

        beforePageLoadTime = null;
        afterPageLoadTime = null;
        afterPageChangeTime = null;
    };

    this.after('initialize', function () {
        this.on('data:navigation:before-page-load', this._beforePageLoad);
        this.on('data:navigation:after-page-load', this._afterPageLoad);
        this.on('ui:navigation:after-page-change', this._afterPageChange);
    });
}

module.exports = defineComponent.component(NavigationTimeMetrics);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/navigation-time-metrics.js